 import React from 'react';
import { connect } from "react-redux";
import { Label, Button, Checkbox, Icon, Dropdown, Card, Input } from "semantic-ui-react";
import { Wrapper } from "./style.js";
import clsx from 'clsx';
import ProgressRing from './components/ProgressRing';
import UnitList from './components/UnitList';
import PartialList from './components/PartialList';
import _ from "lodash";

   
//a unit step is complette only when all debriefs in that unit are completed for a step
const allDebriefStages = (debriefs, index, complete) => 
    debriefs.filter(d => (!complete && !d.id) || Array.isArray(d.completed_stages) && d.completed_stages[index] === complete).length === debriefs.length;

//count number of units that have completed a step
const countByStep = (groups, index, complete = true) => Object.keys(groups)
    .map( key => allDebriefStages(groups[key], index, complete) ? 1 : 0)
    .reduce( (a,b) => a+b, 0);

//partially complete groups are not all complete and not all incomplete
const partialComplete = (groups, index) => Object.keys(groups)
    .filter( key => !allDebriefStages(groups[key], index, true) && !allDebriefStages(groups[key], index, false))
    .map( key => groups[key]);

const filterByStep = (groups, index, complete = true) => Object.keys(groups)
    .filter( key => allDebriefStages(groups[key], index, complete));

class DebriefDashboard extends React.Component {
    constructor(props) {
        super(props);
      
        //group by unit name
        const debriefs = _.groupBy(props.summaryReport.debriefs, d => d.unit);

        this.state = {
          steps: [{
                name: 'Prepare to Debrief',
                url: 'prepare'
            },
            {
                name:'Record Notes',
                url: 'record'
            },
            {
                name:'Review & Reflect',
                url: 'review'
            },
            {
                name:'Develop Action Plan',
                url: 'develop'
            },
            {
                name: 'Take Action',
                url: 'action'
            }].map((step,index) => ({
            ...step,
            index,
            complete_count: countByStep(debriefs, index),
            complete: filterByStep(debriefs, index, true),
            incomplete: filterByStep(debriefs, index, false),
            partial: partialComplete(debriefs, index),
            open: false
        })).map( step => ({
            ...step,
            available: step.complete.length > 0 || step.incomplete.length > 0
        }))
      }
      this.toggleStep = this.toggleStep.bind(this);
    }

    toggleStep(index) {
        const { steps } = this.state;
        const step = steps[index];

        if (step.complete.length === 0 && step.incomplete.length ===0) return;

        this.setState({
            steps: steps.map( (s,i) => i === index ? {...s, open: !s.open} : s)
        })
    }

    render() {
        const { summaryReport } = this.props;
        const { steps } = this.state;

        const totalReportingUnits = summaryReport.workSettings.filter(w => parseInt(w.count) >= 5 && parseInt(w.response_rate) >= 40).length;
        const totalUnits = summaryReport.unitsWithoutReportFlag 
            ? totalReportingUnits + summaryReport.workSettingsNoReport.length
            : totalReportingUnits

        return (
              <Wrapper>
                <Card.Group>
                    {steps.map( (step, stepIndex) => (
                    <Card key={stepIndex}>
                        <Card.Content>
                            <div className={clsx({summary:true, available: step.available, open:step.open})} onClick={() => this.toggleStep(stepIndex)}>
                                <div className="heading">
                                    <Label><Icon name="check"/> Step {step.index+1}</Label>
                                    <Card.Header>{step.name}</Card.Header>
                                    <Card.Meta><label>{step.complete_count}</label> out of <label>{totalUnits}</label> Work Settings Completed</Card.Meta>
                                </div>
                                <div className="progress">
                                    <ProgressRing progress={totalUnits > 0 ? step.complete_count / totalUnits * 100 : 0}/>
                                </div>
                                <div className="indicator">
                                    {step.available && <Icon name="chevron right" className={clsx({open:step.open})}/>}
                                </div>
                            </div>
                            <div className={clsx({detail:true, open:step.open})}>
                                <div className="columns">
                                    {step.complete.length > 0 && <UnitList completed debriefs={step.complete} step={step} header/>}
                                    {step.complete.length > 0 && step.incomplete.length > 0 && <div className="spacer"/>}
                                    {step.incomplete.length > 0 && <UnitList completed={false} debriefs={step.incomplete} step={step} header/>}
                                </div>
                                {step.partial.length > 0 && <PartialList groups={step.partial} step={stepIndex}/>}
                            </div>                       
                        </Card.Content>
                    </Card>))}
                </Card.Group>
              </Wrapper>
          );        
    }

}

export default connect(store => {
    return {
      summaryReport: store.summaryReport.summaryReport,
      user: store.user
    };
  })(DebriefDashboard);
  


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefDashboard/index.jsx